import cmtItemvenddescriptionsServiceGen from "./generated/cmtItemvenddescriptionsServiceGen";

class cmtItemvenddescriptionsService extends cmtItemvenddescriptionsServiceGen {
}

export default cmtItemvenddescriptionsService;